<template>
  <div class="flex items-center justify-center">

    <div class="card cursor-pointer-fc" @click="isToggle = !isToggle">
      <div :class="isToggle ? 'activeTransitionFront' : ''" class="card__front card__part " :style="`background: ${cardColor}`">
        <h1 class="text-center break-words" style="font-size: 3rem">{{ textFront }}</h1>
      </div>

      <div :class="isToggle ? 'activeTransitionBack' : ''" class="card__back card__part " :style="`background: ${cardColor}`">
        <h1 class="text-center break-words" style="font-size: 3rem;">{{ textBack }}</h1>
      </div>

    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      isToggle: false,
    }
  },
  props: {
    cardColor: {
      type: String,
      default: '#fd696b'
    },
    textFront: {
      type: String,
      default: ''
    },
    textBack: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>



.card{
  width: 40rem;
  height: 25rem;
  -webkit-perspective: 600px;
  -moz-perspective: 600px;
  perspective:600px;
}

.card__part{
  top: 0;
  position: absolute;
  z-index: 1000;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40rem;
  height: 25rem;
  border-radius: 8px;
  transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1);
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
}

.card__front{
  padding: 18px;
  -webkit-transform: rotateX(0);
  -moz-transform: rotateX(0);
  transform-style: flat;
}

.card__back {
  padding: 18px;
  -webkit-transform: rotateX(-180deg);
  -moz-transform: rotateX(-180deg);
  transform-style: flat;
}

.activeTransitionFront {
  -webkit-transform: rotateX(180deg);
  -moz-transform: rotateX(180deg);
  transform-style: flat;
}

.activeTransitionBack {
  -webkit-transform: rotateX(0deg);
  -moz-transform: rotateX(0deg);
  transform-style: flat;
}
</style>
